<template>
  <div class="tournament-content-tab tab-results" v-bind:class="{'tournament-content-active-tab':activeTab == 6}">

    <!-- Шапка: підсумок по турніру -->
    <section class="adm-panel adm-head">
      <h3 class="adm-title">Результати <span class="adm-count">{{ bracketResults.length }}</span></h3>
      <a class="adm-btn adm-btn-sm" v-if="tournamentId" :href="baseUrlServer + '/tournament-report/print-pdf?id=' + tournamentId" target="_blank" rel="noopener">
        <tkd-icon name="file"/> Звіт турніру (PDF)
      </a>
    </section>

    <div class="res-stats">
      <div class="res-stat">
        <span class="res-stat-value">{{ finishedCount }}<small>/{{ bracketResults.length }}</small></span>
        <span class="res-stat-label">категорій-сіток завершено</span>
        <span class="res-progress" aria-hidden="true"><span :style="{ width: finishedPercent + '%' }"></span></span>
      </div>
      <div class="res-stat">
        <span class="res-stat-value"><tkd-icon name="medal-gold"/> {{ medalTotals.gold }}</span>
        <span class="res-stat-label">золото</span>
      </div>
      <div class="res-stat">
        <span class="res-stat-value"><tkd-icon name="medal-silver"/> {{ medalTotals.silver }}</span>
        <span class="res-stat-label">срібло</span>
      </div>
      <div class="res-stat">
        <span class="res-stat-value"><tkd-icon name="medal-bronze"/> {{ medalTotals.bronze }}</span>
        <span class="res-stat-label">бронза</span>
      </div>
    </div>

    <!-- Замовлення нагород: рахуємо від кількості учасників, до турніру -->
    <section class="adm-panel res-order">
      <div class="res-side-head">
        <h3 class="res-side-title">Нагороди: що замовити</h3>
        <label class="res-order-option">
          <input type="checkbox" v-model="poomsaeTwoBronze">
          Пумсе / списки: дві бронзи
        </label>
      </div>
      <p class="res-side-hint">
        Сітки: 1 учасник — <tkd-icon name="medal-gold"/>; 2 — <tkd-icon name="medal-gold"/><tkd-icon name="medal-silver"/>; 3 — <tkd-icon name="medal-gold"/><tkd-icon name="medal-silver"/><tkd-icon name="medal-bronze"/>; 4 і більше — <tkd-icon name="medal-gold"/><tkd-icon name="medal-silver"/><tkd-icon name="medal-bronze"/><tkd-icon name="medal-bronze"/>.
        Списки: <tkd-icon name="medal-gold"/><tkd-icon name="medal-silver"/> і {{ poomsaeTwoBronze ? 'дві' : 'одна' }} <tkd-icon name="medal-bronze"/> (якщо учасників вистачає).
        Грамота — кожному призеру. Пари й команди («Іваненко / Петренко») — медаль і грамота кожному.
      </p>

      <div class="res-order-totals">
        <div class="res-order-tile gold"><span><tkd-icon name="medal-gold"/></span><b>{{ awardOrder.total.gold }}</b><small>золоті медалі</small></div>
        <div class="res-order-tile silver"><span><tkd-icon name="medal-silver"/></span><b>{{ awardOrder.total.silver }}</b><small>срібні медалі</small></div>
        <div class="res-order-tile bronze"><span><tkd-icon name="medal-bronze"/></span><b>{{ awardOrder.total.bronze }}</b><small>бронзові медалі</small></div>
        <div class="res-order-tile diploma"><span><tkd-icon name="diploma"/></span><b>{{ awardOrder.total.diplomas }}</b><small>грамот</small></div>
      </div>

      <div class="adm-table-wrap">
        <table class="adm-table res-order-table">
          <thead>
            <tr>
              <th>Вид</th>
              <th>Категорій</th>
              <th title="Золото"><tkd-icon name="medal-gold"/></th>
              <th title="Срібло"><tkd-icon name="medal-silver"/></th>
              <th title="Бронза"><tkd-icon name="medal-bronze"/></th>
              <th><tkd-icon name="diploma"/> Грамоти</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="g in awardOrder.groups" :key="g.key">
              <td class="res-team-name">{{ g.label }}</td>
              <td>{{ g.categories }}</td>
              <td>{{ g.gold }}</td>
              <td>{{ g.silver }}</td>
              <td>{{ g.bronze }}</td>
              <td>{{ g.diplomas }}</td>
            </tr>
            <tr class="res-order-sum">
              <td class="res-team-name">Разом</td>
              <td>{{ awardOrder.total.categories }}</td>
              <td>{{ awardOrder.total.gold }}</td>
              <td>{{ awardOrder.total.silver }}</td>
              <td>{{ awardOrder.total.bronze }}</td>
              <td>{{ awardOrder.total.diplomas }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <details class="res-order-details" v-if="awardOrder.rows.length">
        <summary>По категоріях ({{ awardOrder.rows.length }}) — для пакування</summary>
        <div class="adm-table-wrap">
          <table class="adm-table res-order-table">
            <thead>
              <tr>
                <th>Категорія</th>
                <th><tkd-icon name="team"/></th>
                <th title="Людей в одному записі (пара, команда)">Склад</th>
                <th><tkd-icon name="medal-gold"/></th>
                <th><tkd-icon name="medal-silver"/></th>
                <th><tkd-icon name="medal-bronze"/></th>
                <th><tkd-icon name="diploma"/></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in awardOrder.rows" :key="row.id">
                <td class="res-team-name">{{ row.name }}</td>
                <td>{{ row.count }}</td>
                <td><span class="adm-chip" v-if="row.people > 1">×{{ row.people }}</span><span v-else>1</span></td>
                <td>{{ row.gold }}</td>
                <td>{{ row.silver }}</td>
                <td>{{ row.bronze }}</td>
                <td>{{ row.diplomas }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </details>
    </section>

    <div class="res-layout">
      <!-- Категорії -->
      <section class="res-main">
        <div class="adm-panel res-toolbar">
          <div class="adm-segmented" role="tablist" aria-label="Стан категорій">
            <button type="button" v-for="s in statusFilters" :key="s.key"
                    role="tab" :aria-selected="statusFilter === s.key ? 'true' : 'false'"
                    :class="{ active: statusFilter === s.key }" @click="statusFilter = s.key">
              {{ s.label }} <span class="adm-seg-count">{{ s.count }}</span>
            </button>
          </div>
          <input type="search" class="adm-input res-search" v-model="search"
                 placeholder="Пошук: категорія, ПІБ, клуб" aria-label="Пошук у результатах">
        </div>

        <div class="res-cards" v-if="visibleResults.length">
          <article class="res-card" v-for="r in visibleResults" :key="r.id" :class="'is-' + r.status">
            <header class="res-card-head">
              <h4 class="res-card-title">{{ r.name }}</h4>
              <div class="res-card-meta">
                <span class="adm-chip"><tkd-icon name="team"/> {{ r.count }}</span>
                <span class="adm-chip ok" v-if="r.status === 'finished'">завершено</span>
                <span class="adm-chip warn" v-else-if="r.status === 'progress'">триває</span>
                <span class="adm-chip" v-else>немає жеребкування</span>
              </div>
            </header>

            <ol class="res-places" v-if="r.places.length">
              <li v-for="(p, i) in r.places" :key="r.id + '_' + i" :class="'place-' + p.place">
                <span class="res-medal" aria-hidden="true"><tkd-icon :name="medalIcon(p.place)"/></span>
                <span class="res-place-num">{{ p.place }} місце</span>
                <span class="res-person">
                  <b>{{ p.name }}</b>
                  <small v-if="p.club">{{ p.club }}</small>
                </span>
              </li>
            </ol>
            <p class="res-card-empty" v-else>Поєдинки ще не проведені</p>

            <footer class="res-card-foot">
              <router-link class="adm-btn adm-btn-sm adm-btn-ghost" :to="bracketLink(r.id)"><tkd-icon name="bracket"/> Сітка</router-link>
              <a class="adm-btn adm-btn-sm adm-btn-ghost" :href="baseUrlServer + '/tournament-result/print-pdf?category=' + r.id" target="_blank" rel="noopener"><tkd-icon name="file"/> PDF</a>
            </footer>
          </article>
        </div>

        <section class="adm-empty" v-else>
          <div class="adm-empty-icon" aria-hidden="true"><tkd-icon name="trophy"/></div>
          <p v-if="bracketResults.length">Нічого не знайдено</p>
          <p v-else>У турнірі ще немає категорій-сіток</p>
        </section>

        <!-- Пумсе / списки: місця рахує сервер, тут лише PDF -->
        <div class="adm-panel res-lists" v-if="listCategories.length">
          <h3 class="res-side-title">Категорії-списки (пумсе)</h3>
          <ul>
            <li v-for="c in listCategories" :key="c.id">
              <span class="res-list-name">{{ c.fullname || c.name }}</span>
              <a class="adm-btn adm-btn-sm adm-btn-ghost" :href="baseUrlServer + '/tournament/print-pdf-list-result?sort=place&category=' + c.id" target="_blank" rel="noopener"><tkd-icon name="file"/> Результати PDF</a>
            </li>
          </ul>
        </div>
      </section>

      <!-- Командний залік -->
      <aside class="adm-panel res-side">
        <div class="res-side-head">
          <h3 class="res-side-title">Командний залік</h3>
          <div class="adm-segmented" role="tablist" aria-label="Групування заліку">
            <button type="button" role="tab" :aria-selected="teamBy === 'club' ? 'true' : 'false'" :class="{ active: teamBy === 'club' }" @click="teamBy = 'club'">Клуби</button>
            <button type="button" role="tab" :aria-selected="teamBy === 'oblast' ? 'true' : 'false'" :class="{ active: teamBy === 'oblast' }" @click="teamBy = 'oblast'">Області</button>
          </div>
        </div>
        <p class="res-side-hint">Лише сітки. Бали: <tkd-icon name="medal-gold"/> 3 · <tkd-icon name="medal-silver"/> 2 · <tkd-icon name="medal-bronze"/> 1</p>

        <div class="adm-table-wrap" v-if="teamStandings.length">
          <table class="adm-table res-team-table">
            <thead>
              <tr>
                <th>#</th>
                <th>{{ teamBy === 'club' ? 'Клуб' : 'Область' }}</th>
                <th title="Золото"><tkd-icon name="medal-gold"/></th>
                <th title="Срібло"><tkd-icon name="medal-silver"/></th>
                <th title="Бронза"><tkd-icon name="medal-bronze"/></th>
                <th>Бали</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(t, i) in teamStandings" :key="t.name">
                <td class="res-rank" :class="{ top: i < 3 }">{{ i + 1 }}</td>
                <td class="res-team-name">{{ t.name }}</td>
                <td>{{ t.gold }}</td>
                <td>{{ t.silver }}</td>
                <td>{{ t.bronze }}</td>
                <td><b>{{ t.points }}</b></td>
              </tr>
            </tbody>
          </table>
        </div>
        <p class="res-card-empty" v-else>Медалей ще немає</p>
      </aside>
    </div>
  </div>
</template>

<script>
  import {baseUrlServer} from 'src/api/user.js';
  import 'src/assets/css/tkd-theme.css';
  import 'src/assets/css/tkd-admin.css';

  const MEDAL_POINTS = {1: 3, 2: 2, 3: 1};

  export default {
    name: "tab-results",
    props: ['category'],
    data() {
      return {
        baseUrlServer: baseUrlServer,
        statusFilter: 'all',
        search: '',
        teamBy: 'club',
        poomsaeTwoBronze: false,
      }
    },
    computed: {
      activeTab() {
        return this.$store.getters['settings/activeTournamentTab'];
      },
      tournamentOne() {
        return this.$store.getters['tournament/tournamentOne'];
      },
      tournamentId() {
        return this.tournamentOne && this.tournamentOne.data && this.tournamentOne.data.item ? this.tournamentOne.data.item.id : null;
      },
      allProtocols() {
        if (this.tournamentOne && this.tournamentOne.data && this.tournamentOne.data.item && this.tournamentOne.data.item.protocols) {
          return this.tournamentOne.data.item.protocols;
        }
        return [];
      },
      listCategories() {
        return this.allProtocols.filter(c => c.show_type != 1 && Number(c.count_sportsmans || c.count || 0) > 0);
      },
      // місця по сітках з drawdata (лише читання)
      bracketResults() {
        return this.allProtocols
          .filter(c => c.show_type == 1)
          .map(c => this.categoryResult(c));
      },
      finishedCount() {
        return this.bracketResults.filter(r => r.status === 'finished').length;
      },
      finishedPercent() {
        return this.bracketResults.length ? Math.round(this.finishedCount / this.bracketResults.length * 100) : 0;
      },
      medalTotals() {
        const totals = {gold: 0, silver: 0, bronze: 0};
        this.bracketResults.forEach(r => r.places.forEach(p => {
          if (p.place === 1) totals.gold++;
          else if (p.place === 2) totals.silver++;
          else totals.bronze++;
        }));
        return totals;
      },
      statusFilters() {
        const count = status => this.bracketResults.filter(r => r.status === status).length;
        return [
          {key: 'all', label: 'Усі', count: this.bracketResults.length},
          {key: 'finished', label: 'Завершені', count: count('finished')},
          {key: 'progress', label: 'Тривають', count: count('progress')},
          {key: 'none', label: 'Без жеребкування', count: count('none')},
        ];
      },
      visibleResults() {
        const query = this.search.trim().toLowerCase();
        return this.bracketResults.filter(r => {
          if (this.statusFilter !== 'all' && r.status !== this.statusFilter) return false;
          if (!query) return true;
          return [r.name].concat(r.places.map(p => p.name + ' ' + p.club)).join(' ').toLowerCase().includes(query);
        });
      },
      // скільки медалей і грамот потрібно — від кількості учасників кожної категорії
      awardOrder() {
        const groups = {
          kyorugi: {key: 'kyorugi', label: 'Керугі', categories: 0, gold: 0, silver: 0, bronze: 0, diplomas: 0},
          poomsae: {key: 'poomsae', label: 'Пумсе', categories: 0, gold: 0, silver: 0, bronze: 0, diplomas: 0},
          other: {key: 'other', label: 'Інше', categories: 0, gold: 0, silver: 0, bronze: 0, diplomas: 0},
        };
        const rows = [];

        this.allProtocols.forEach(c => {
          const count = Number(c.count_sportsmans || c.count || 0);
          if (count < 1) return;
          // сітка: бронза обом, хто програв півфінал; список — 1 або 2 бронзи
          const maxBronze = c.show_type == 1 ? 2 : (this.poomsaeTwoBronze ? 2 : 1);
          // пара/команда: "Іваненко / Петренко" — медаль і грамота кожному, беремо найбільший склад у категорії
          const people = this.teamSize(c);
          const gold = people;
          const silver = count >= 2 ? people : 0;
          const bronze = Math.max(0, Math.min(maxBronze, count - 2)) * people;
          const diplomas = gold + silver + bronze;

          const group = c.type == 1 ? groups.kyorugi : c.type == 2 ? groups.poomsae : groups.other;
          group.categories++;
          group.gold += gold;
          group.silver += silver;
          group.bronze += bronze;
          group.diplomas += diplomas;
          rows.push({id: c.id, name: c.fullname || c.name, count, people, gold, silver, bronze, diplomas});
        });

        const list = Object.values(groups).filter(g => g.categories > 0);
        const total = list.reduce((sum, g) => {
          ['categories', 'gold', 'silver', 'bronze', 'diplomas'].forEach(k => { sum[k] += g[k]; });
          return sum;
        }, {categories: 0, gold: 0, silver: 0, bronze: 0, diplomas: 0});

        return {groups: list, total, rows};
      },
      teamStandings() {
        const teams = {};
        this.bracketResults.forEach(r => r.places.forEach(p => {
          const name = (this.teamBy === 'club' ? p.organization : p.oblast) || 'Без назви';
          const team = teams[name] || (teams[name] = {name, gold: 0, silver: 0, bronze: 0, points: 0});
          if (p.place === 1) team.gold++;
          else if (p.place === 2) team.silver++;
          else team.bronze++;
          team.points += MEDAL_POINTS[p.place];
        }));
        return Object.values(teams).sort((a, b) =>
          b.gold - a.gold || b.silver - a.silver || b.bronze - a.bronze || b.points - a.points || a.name.localeCompare(b.name, 'uk'));
      },
    },
    methods: {
      // позиції як у сітці жеребкування: переможець поєдинку L_i стоїть на (L−1)_(i/2) (nextPosition у UserBracketsContructor).
      // 0_0 — переможець, 1_x — фінал, 2_x — півфінал (бронза обом, хто програв півфінал)
      categoryResult(c) {
        const drawdata = Array.isArray(c.drawdata) ? c.drawdata : [];
        const byPosition = {};
        drawdata.forEach(item => {
          if (item && item.sp_id && item.sp_id != 0) byPosition[item.position] = item;
        });
        const spId = position => byPosition[position] ? Number(byPosition[position].sp_id) : 0;
        // клуб/область — зі списку спортсменів категорії (у drawdata старших кіл їх може не бути)
        const sportsmans = Array.isArray(c.sportsmans) ? c.sportsmans : Object.values(c.sportsmans || {});
        const place = (item, num) => {
          const sp = sportsmans.find(s => Number(s.id) === Number(item.sp_id)) || {};
          const organization = item.organization || sp.organization || '';
          const oblast = item.oblast || sp.oblast || '';
          return {
            place: num,
            name: item.name || sp.name,
            organization,
            oblast,
            club: [oblast, organization].filter(Boolean).join(' / '),
          };
        };

        const places = [];
        const winner = byPosition['0_0'];
        if (winner) {
          places.push(place(winner, 1));
          const finalist = ['1_0', '1_1'].map(p => byPosition[p]).find(item => item && Number(item.sp_id) !== spId('0_0'));
          if (finalist) places.push(place(finalist, 2));
        }
        // бронза: у півфіналі були обидва, і один уже пройшов у фінал
        [0, 1].forEach(i => {
          const blue = byPosition['2_' + (i * 2)];
          const red = byPosition['2_' + (i * 2 + 1)];
          const advanced = spId('1_' + i);
          if (!blue || !red || !advanced) return;
          const loser = Number(blue.sp_id) === advanced ? red : Number(red.sp_id) === advanced ? blue : null;
          if (loser) places.push(place(loser, 3));
        });

        let status = 'none';
        if (winner) status = 'finished';
        else if (Object.keys(byPosition).length) status = 'progress';

        return {
          id: c.id,
          name: c.fullname || c.name,
          count: c.count_sportsmans || c.count || 0,
          status,
          places,
        };
      },
      // скільки людей в одному записі: "А / Б / В" → 3
      peopleInName(name) {
        return String(name || '').split('/').filter(part => part.trim()).length || 1;
      },
      teamSize(c) {
        const sportsmans = Array.isArray(c.sportsmans) ? c.sportsmans : Object.values(c.sportsmans || {});
        return sportsmans.reduce((max, s) => Math.max(max, this.peopleInName(s && s.name)), 1);
      },
      medalIcon(place) {
        return place === 1 ? 'medal-gold' : place === 2 ? 'medal-silver' : 'medal-bronze';
      },
      // та сама адреса, що й у вкладки жеребкування
      bracketLink(categoryId) {
        return {path: `/user/tournaments/overview/${this.tournamentId}/bracket/${categoryId}`, query: {tab: 'drawing'}};
      },
    },
  }
</script>

<style scoped>
.tab-results {
  font-family: var(--tkd-font);
  color: var(--tkd-text);
}

.res-stats {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 16px;
}

.res-stat {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 16px 18px;
  background: var(--tkd-surface);
  border: 1px solid var(--tkd-border);
  border-radius: var(--tkd-radius-lg);
  box-shadow: var(--tkd-shadow);
}

.res-stat-value {
  font-size: 26px;
  font-weight: 800;
  line-height: 1.1;
}

.res-stat-value small {
  font-size: 15px;
  font-weight: 700;
  color: var(--tkd-muted);
}

.res-stat-label {
  font-size: 13px;
  color: var(--tkd-muted);
}

.res-progress {
  height: 6px;
  margin-top: 4px;
  border-radius: 999px;
  background: var(--tkd-bg);
  overflow: hidden;
}

.res-progress span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: var(--tkd-gradient-btn);
  transition: width .4s ease;
}

.res-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 380px;
  gap: 16px;
  align-items: start;
}

.res-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.res-search {
  flex: 1 1 220px;
  max-width: 320px;
}

.res-cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 12px;
  margin-bottom: 16px;
}

.res-card {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px 18px;
  background: var(--tkd-surface);
  border: 1px solid var(--tkd-border);
  border-top: 4px solid var(--tkd-border);
  border-radius: var(--tkd-radius-lg);
  box-shadow: var(--tkd-shadow);
}

.res-card.is-finished { border-top-color: var(--tkd-yellow); }
.res-card.is-progress { border-top-color: var(--tkd-blue); }

.res-card-head {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.res-card-title {
  margin: 0;
  font-size: 15px;
  font-weight: 800;
  line-height: 1.3;
  overflow-wrap: anywhere;
}

.res-card-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.res-places {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.res-places li {
  display: grid;
  grid-template-columns: 28px 64px minmax(0, 1fr);
  align-items: center;
  gap: 6px;
  padding: 6px 8px;
  border-radius: var(--tkd-radius);
  background: var(--tkd-bg);
}

.res-places li.place-1 { background: rgba(255, 213, 0, .16); }

.res-medal { font-size: 20px; }

.res-place-num {
  font-size: 12px;
  font-weight: 700;
  color: var(--tkd-muted);
}

.res-person {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.res-person b {
  font-size: 14px;
  overflow-wrap: anywhere;
}

.res-person small {
  font-size: 12px;
  color: var(--tkd-muted);
  overflow-wrap: anywhere;
}

.res-card-empty {
  margin: 0;
  font-size: 13px;
  color: var(--tkd-muted);
}

.res-card-foot {
  display: flex;
  gap: 8px;
  margin-top: auto;
}

.res-side {
  position: sticky;
  top: 70px;
}

.res-side-head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.res-side-title {
  margin: 0;
  font-size: 18px;
  font-weight: 800;
}

.res-side-hint {
  margin: 8px 0 12px;
  font-size: 12px;
  color: var(--tkd-muted);
}

.res-team-table th,
.res-team-table td {
  padding: 8px;
  text-align: center;
}

.res-team-table th:nth-child(2),
.res-team-table td.res-team-name {
  text-align: left;
}

.res-team-name { overflow-wrap: anywhere; }

.res-rank.top {
  font-weight: 800;
  color: var(--tkd-blue);
}

.res-order-option {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  text-transform: none;
  color: var(--tkd-text);
  cursor: pointer;
}

.res-order-option input { width: 16px; height: 16px; margin: 0; }

.res-order-totals {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
  margin-bottom: 14px;
}

.res-order-tile {
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-rows: auto auto;
  column-gap: 10px;
  align-items: center;
  padding: 12px 14px;
  border: 1px solid var(--tkd-border);
  border-left: 4px solid var(--tkd-border);
  border-radius: var(--tkd-radius);
  background: var(--tkd-bg);
}

.res-order-tile span { grid-row: span 2; font-size: 26px; }
.res-order-tile b { font-size: 24px; font-weight: 800; line-height: 1.1; }
.res-order-tile small { font-size: 12px; color: var(--tkd-muted); }
.res-order-tile.gold { border-left-color: var(--tkd-yellow); }
.res-order-tile.diploma { border-left-color: var(--tkd-blue); }

.res-order-table th,
.res-order-table td {
  padding: 8px;
  text-align: center;
}

.res-order-table th:first-child,
.res-order-table td:first-child { text-align: left; }

.res-order-sum td { font-weight: 800; }

.res-order-details { margin-top: 12px; }

.res-order-details summary {
  cursor: pointer;
  font-size: 14px;
  font-weight: 700;
  color: var(--tkd-blue);
}

.res-order-details summary:focus-visible {
  outline: 2px solid var(--tkd-blue);
  outline-offset: 2px;
  border-radius: 4px;
}

.res-order-details .adm-table-wrap {
  max-height: 420px;
  margin-top: 10px;
  overflow: auto;
}

.res-lists ul {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 12px 0 0;
  padding: 0;
  list-style: none;
}

.res-lists li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding-bottom: 8px;
  border-bottom: 1px solid var(--tkd-border);
}

.res-list-name {
  font-size: 14px;
  font-weight: 600;
  overflow-wrap: anywhere;
}

@media (max-width: 1199px) {
  .res-layout { grid-template-columns: minmax(0, 1fr); }
  .res-side { position: static; }
}

@media (max-width: 767px) {
  .res-stats { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .res-order-totals { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .res-search { max-width: none; }
  .res-lists li { flex-direction: column; align-items: flex-start; }
}

@media (max-width: 480px) {
  .res-cards { grid-template-columns: minmax(0, 1fr); }
  .res-stat-value { font-size: 22px; }
}

@media (prefers-reduced-motion: reduce) {
  .res-progress span { transition: none; }
}
</style>
